import React, { useState, useEffect, useRef } from 'react'
import HStack from './HStack'
import VStack from './VStack'
import RStack from './RStack'

import doctor_zh from './images/doctor_zh.webp'
import doctor_dc from './images/doctor_dc.webp'
import doctor_pm from './images/doctor_pm.webp'
import { ReactComponent as MobileIcon } from './images/mobile-screen-solid.svg'
import Data from './data/Data'

const theme = Data.theme

const componentStyles = {
    small: {
        container: {
            root: {
                margin: 40,
                background: 'white',
                borderRadius: 10,
                width: 300,
                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
            }
        },
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px 10px',
            }
        },
        imageContainer: {
            root: {
                padding: '0',
                //height: 220,
            }
        },
        headerText: { root: { fontSize: 22, fontWeight: 500, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        detailText: { root: { alignItems: 'center', fontSize: 16, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    },
    medium: {
        container: {
            root: {
                margin: 20,
                minWidth: 250,
                maxWidth: 350,
                background: 'white',
                borderRadius: 10,
                width: 300,
                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
            }
        },
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                padding: 20,
            }
        },
        imageContainer: {
            root: {
                padding: '0',
            }
        },
        headerText: { root: { fontSize: 22, fontWeight: 500, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        detailText: { root: { fontSize: 16, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    },
    large: {
        container: {
            root: {
                margin: 20,
                minWidth: 250,
                maxWidth: 350,
                background: 'white',
                borderRadius: 10,
                width: 300,
                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
            }
        },
        textContainer: {
            root: {
                justifyContent: 'center',
                alignItems: 'center',
                padding: 20,
            }
        },
        imageContainer: {
            root: {
                padding: '0',
            }
        },
        headerText: { root: { fontSize: 22, fontWeight: 500, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        detailText: { root: { fontSize: 16, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    }
}

export default function Doctors(props) {
    const {
        size = 'large',
    } = props

    const cStyles = componentStyles[size] ?? {}


    return (
        <>
            <RStack size={size}
                styles={{ root: { justifyContent: 'space-around', flexWrap: 'wrap', margin: '0 auto' } }}
            >
                {renderDoctor()}
            </RStack>
        </>
    )

    function renderDoctor() {
        return Data.doctorData.map((d, i) => {
            return (
                <VStack key={i} styles={cStyles.container}>
                    <VStack styles={cStyles.imageContainer}>
                        <img src={d.image} alt='doctor'
                            style={{
                                objectFit: 'cover', objectPosition: '0% 0%', background: 'white', opacity: '1',
                                borderRadius: '10px 10px 0 0', height: 220,
                            }} />
                    </VStack>
                    <VStack styles={cStyles.textContainer}>
                        <VStack styles={cStyles.headerText}>
                            <span>{d.name}</span>
                        </VStack>
                        <VStack styles={cStyles.detailText}>
                            <span>{d.discipline}</span>
                        </VStack>
                        <HStack styles={cStyles.detailText}>
                            <MobileIcon style={{ width: 20, height: 20, fill: '#444', margin: '0px 5px' }} />
                            <a href={d.contactLink} target="_top" style={{ textDecoration: 'none' }}>
                                <span style={{ color: theme.colours.primaryAlt2, textDecoration: 'underline', paddingRight: 20 }}>
                                    {d.contact}
                                </span>
                            </a>
                        </HStack>
                    </VStack>
                </VStack>
            )
        })
    }
}